import { ReactElement } from "react";
import style from "./style.module.scss";
import SideImage from "@components/shared/sideImage";

export default function Lawsuits(): ReactElement {
    return (
        <div className={style.wrapper}>
            <div className={style.inner}>
                <SideImage
                    title={
                        "What Are the Health Risks Associated With Exposure to Roundup?"
                    }
                    content={[
                        "Roundup has been linked to health risks such as non-Hodgkin's lymphoma, liver and kidney damage, reproductive problems, and endocrine system disruption. The International Agency for Research on Cancer (IARC) has said that glyphosate, its main active ingredient, is likely to cause cancer in humans. It is also toxic to bees and other wildlife, and many countries have limited or banned its use.",
                    ]}
                    image={"/bestrounduplawyers/assets/images/roundup-1.jpg"}
                    imageClassName={
                        "md:w-[530px] md:h-[425px] w-[300px] h-[200px] mt-3"
                    }
                    titleColor={"#0a6938"}
                    showScrollButton={false}
                    flip
                />
                <SideImage
                    title={"What Is the Roundup Lawsuit?"}
                    content={[
                        "The Roundup lawsuit is a group of lawsuits against Monsanto, the company that first made the herbicide Roundup. The lawsuits claim that using Roundup can cause non-Hodgkin's lymphoma and other types of cancer. In these lawsuits, people say that Monsanto didn't warn people enough about the possible health risks of Roundup and that the company hid or changed scientific data to downplay the product's dangers.",
                        "Thousands of individuals have filed lawsuits against Monsanto and its parent company, Bayer AG. The lawsuits have sparked a broader debate about the safety of glyphosate-based herbicides and the role of corporations in protecting public health.",
                    ]}
                    image={"/bestrounduplawyers/assets/images/roundup-2.jpg"}
                    imageClassName={
                        "md:w-[530px] md:h-[425px] w-[300px] h-[200px] mt-3"
                    }
                    titleColor={"#0a6938"}
                    showScrollButton={false}
                />
            </div>
        </div>
    );
}
